import React from "react";
import { Container, Paper, Typography, Box, Grid } from "@mui/material";

interface SurfaceProps {
  title?: string;
  textAlign?: "left" | "center" | "right";
  children?: React.ReactNode;
}

const Surface = ({ title, textAlign = "left", children }: SurfaceProps) => {
  return (
    <Paper elevation={3} style={styles.paper}>
      {title && (
        <Typography variant="h5" textAlign={textAlign} gutterBottom>
          {title}
        </Typography>
      )}
      <div style={{ textAlign }}>{children}</div>
    </Paper>
  );
};

const styles = {
  paper: {
    padding: 10,
    backgroundColor: "rgba(244, 246, 249, 1)",
  },
};

export default Surface;
